import * as React from 'react';

import styled from 'styled-components';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

interface TrackInfoTitleCtrlProps {
  className?: string;
  songName: string;
}

export const TrackInfoTitleCtrl: React.FC<TrackInfoTitleCtrlProps> = ({
  className,
  songName,
}) => {
  return (
    <MotionOpacity className={className}>
      <Typography
        className="track-info-title"
        type="subheader"
        customFont="semi-bold"
      >
        {songName}
      </Typography>
    </MotionOpacity>
  );
};

export default styled(TrackInfoTitleCtrl)`
  width: 100%;
  
  .track-info-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
